import React, { Component } from 'react';
import { observer } from 'mobx-react'
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import LoginStore from '../stores/LoginStore.js';

class dialogObj extends Component {
  handleClose = () => {
    LoginStore.open = false
  };

  render() {
    const actions = [
      <FlatButton
        label="關閉"
        primary={true}
        onTouchTap={this.handleClose}
        />,
    ];

    return (
      <div>
        <Dialog
          actions={actions}
          modal={false}
          open={LoginStore.open}
          onRequestClose={this.handleClose}
          >
          {LoginStore.dialogText}
        </Dialog>
      </div>
    );
  }
}

export default observer(dialogObj)



// WEBPACK FOOTER //
// ./src/components/Dialog.js